import { userSessionStore } from '../user-session-store'

function firstTimeLogin() {
  const session = userSessionStore.readUserSession()
  return session?.firstTimeLogin
}

export { firstTimeLogin }